import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EducationApplicationResponse } from "services";

interface State {
    isLoadingEducations: boolean;
    errorMessage: string | undefined;
    educationApplication?: EducationApplicationResponse;
    educationApplicationError?: boolean;
}

const initialState: State = {
    isLoadingEducations: false,
    errorMessage: undefined,
    educationApplication: undefined,
    educationApplicationError: undefined,
};

const educationsSlice = createSlice({
    name: "Educations",
    initialState: initialState,
    reducers: {
        getEducationApplicationSuccess: (
            state,
            action: PayloadAction<{ response: EducationApplicationResponse }>
        ) => {
            state.isLoadingEducations = false;
            state.educationApplication = action.payload.response;
        },
        getEducationsApplicationError: (state, action: PayloadAction<{ error: boolean }>) => {
            state.isLoadingEducations = false;
            state.educationApplicationError = action.payload.error;
        },
    },
});

const { actions } = educationsSlice;

export const { getEducationApplicationSuccess, getEducationsApplicationError } = actions;

export const educationsReducer = educationsSlice.reducer;
